import styled from 'styled-components';
import photo2 from 'assets/images/photo2.jpg';
import photo3_1 from 'assets/images/photo3-1.jpg';
import photo3_2 from 'assets/images/photo3-2.jpg';
import photo4_1 from 'assets/images/photo4-1.jpg';
import photo4_2 from 'assets/images/photo4-2.jpg';
import photo5 from 'assets/images/photo5.jpg';
import photo6_1 from 'assets/images/photo6-1.jpg';
import photo6_2 from 'assets/images/photo6-2.jpg';
import videoBg from 'assets/images/video.jpg';
import { fonts } from 'styles';

export const Container = styled.main`
  width: 100%;
  margin: 0 auto;
`;

export const Content = styled.section`
  margin: 0 auto;
  width: 100%;
  max-width: 1046px;
  display: flex;
  justify-content: flex-end;
  column-gap: 48px;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 32px;
  }
`;

export const Sponsor = styled.span`
  display: flex;
  flex: 1;
  justify-self: flex-start;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 700px;
  font-size: 16px;
  line-height: 28px;

  P {
    margin-bottom: 40px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  h3 {
    font-family: ${fonts.BentonSansMedium};
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 40px;
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  line-height: 32px;
  font-family: ${fonts.BentonSansWideRegular};
  margin-bottom: 48px;
`;

export const InnerPhotoWrapper = styled.div`
  width: 100%;
  margin: 80px 0;

  @media screen and (max-width: 1024px) {
    margin: 64px 0;
  }
`;

export const Photo2 = styled.img.attrs({ src: photo2 })`
  width: 100%;
`;

export const PhotoLegend = styled.div`
  width: 100%;
  max-width: 810px;
  font-size: 14px;
  line-height: 20px;
  margin: 0 auto;

  &.center {
    text-align: center;
  }

  @media screen and (max-width: 1024px) {
    &.center {
      display: none;
    }
  }
`;

export const PhotoLegendMobile = styled(PhotoLegend)`
  display: none;
  @media screen and (max-width: 1024px) {
    padding: 0 32px;
    display: block;
    text-align: left;
  }
`;

export const Wrapper = styled.section`
  width: 100%;
  margin: 96px 0;

  @media screen and (max-width: 1024px) {
    margin: 64px 0;
  }
`;

export const DoblePhotoWrapper = styled.div`
  width: 100%;
  display: flex;
  column-gap: 10px;
  margin: 0 auto 24px auto;

  div.wrapper {
    display: flex;
    width: 100%;
  }

  @media screen and (max-width: 1024px) {
    margin-bottom: 16px;
    flex-direction: column;
    row-gap: 10px;

    div.wrapper {
      flex-direction: column;
    }

    img {
      max-width: 100%;
    }
  }
`;

export const Photo3_1 = styled.img.attrs({ src: photo3_1 })`
  width: 100%;
`;

export const Photo3_2 = styled.img.attrs({ src: photo3_2 })`
  width: 100%;
  max-width: 50%;
`;

export const Photo4_1 = styled.img.attrs({ src: photo4_1 })`
  width: 100%;
`;

export const Photo4_2 = styled.img.attrs({ src: photo4_2 })`
  width: 100%;
  max-width: 50%;
`;

export const Photo5 = styled.img.attrs({ src: photo5 })`
  width: 100%;
`;

export const Photo6_1 = styled.img.attrs({ src: photo6_1 })`
  width: 100%;
`;

export const Photo6_2 = styled.img.attrs({ src: photo6_2 })`
  width: 100%;
  max-width: 50%;
`;

export const VideoWrapper = styled.section`
  width: 100%;
  padding: 0 5%;
  margin: 96px 0;

  div.vimeoWrapper {
    padding: 56.25% 0 0 0;
    position: relative;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  @media screen and (max-width: 1024px) {
    margin: 64px 0;
  }
`;

export const VideoBg = styled.img.attrs({ src: videoBg })`
  width: 100%;
`;
